import script from "./People.vue?vue&type=script&setup=true&lang=js"
export * from "./People.vue?vue&type=script&setup=true&lang=js"

import "./People.vue?vue&type=style&index=0&id=71d0b816&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d0b816"]])

export default __exports__